// compoenent react
import { useState, useEffect } from "react";

// compoenents seplag
import CardSeplag from "./../../components/CardSeplag/index";
import TableSeplag from "../../components/TableSeplag";
import RotuloSeplag from '../../components/RotuloSeplag';
import ModalConsultarCertidoesLegadas from "./ModalConsultarCertidoesLegadas";
// components externos
import CardExibirPDF from '../../components/CardExibirPDF'


// service
import {
    initFiltro,
    Form as initForm,
    exportarAll as exportarAllLegadas,
    camposTabela,
    imprimir,
    imprimirAll,
    buscaPersonalizada as buscaPersonalizadaCertidoesLegadas
} from "../../service/ConsultarCertidoesLegadas";

// primereact
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Button } from "primereact/button";
import download from "downloadjs";
import { InputMask } from "primereact/inputmask";
import { pageableApi } from "../../config/global";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

const initialValueFilter = {
    codgTipoCertidao: null,
    numrCert: null,
    nomeAbreviadoCs: '',
    numrCpfCs: null,
    numrMatriculaPessoalCs: null
}

const Index = () => {

    const dispatch = useDispatch();
    const filterConsultaCertidaoLegada = useSelector((state) => state.filterConsultaCertidaoLegadasReducer);


    const [form, setForm] = useState(initForm);
    const [showModalSearch, setShowModalSearch] = useState(false);
    const [view, setView] = useState(false);
    const [base64Imprimir, setBase64Imprimir] = useState('');
    const [activeImprimir, setActiveImprimir] = useState(false);
    const [certidoesLegadasApi, setCertidoesLegadasApi] = useState(pageableApi)

    const formik = useFormik({
        initialValues: initFiltro,
        onSubmit: (data) => {
            let date = {
                numrCert: data.numrCert != '' ? data.numrCert : null,
                nomeAbreviadoCs: data.nomeAbreviadoCs,
                numrCpfCs: data.numrCpfCs != '' ? data.numrCpfCs.replace(/[^\w\s]|_/g, "") : null,
                numrMatriculaPessoalCs: data.numrMatriculaPessoalCs != '' ? data.numrMatriculaPessoalCs : null
            };

            let paginacao = `page=0&size=${row}`;

            buscaPersonalizadaCertidoesLegadas(paginacao, date).then((res) => {
                setCertidoesLegadasApi(res)
            })
            reduxDispatch(formik.values, 0, row)
        }
    })

    const { pagina, row } = filterConsultaCertidaoLegada
    const { numrCert, nomeAbreviadoCs, numrCpfCs, numrMatriculaPessoalCs } = formik.values

    useEffect(() => {

        let filtroPage = `page=${pagina ? pagina : 0}`;;
        let filtroSize = `size=${row ? row : 10}`

        let paginacao = `${filtroPage}&${filtroSize}`;

        buscaPersonalizadaCertidoesLegadas(paginacao, initialValueFilter).then((res) => {
            setCertidoesLegadasApi(res)
        });

    }, []);

    const reduxDispatch = (parmFiltro, pagina, row = 0) => {

        parmFiltro.numrCpf = parmFiltro.numrCpfCs != '' ? parmFiltro.numrCpfCs.replace(/[^\w\s]|_/g, "") : ''

        dispatch({
            type: "SETFILTER_CONSULTA_CERTIDAO_LEGADA",
            value: {
                filter: { ...parmFiltro },
                pagina: pagina,
                row: row
            }
        });
    }

    function onModalSearch() {
        setForm(initForm);
        setView(false);
        setShowModalSearch(true);
    }

    function onView(rowData) {

        setView(true);
        setShowModalSearch(true);
        setForm(rowData);
    }

    // impressão unitaria
    function onImpressao(rowData) {

        imprimir(rowData).then((res) => {
            setBase64Imprimir('data:application/pdf;base64,' + res.dadosRelatorioBase64)
        });
        setActiveImprimir(true)
    }

    function closeImprimir() {
        setActiveImprimir(false)
    }

    // exportação de todos elementos
    async function onExportacao() {
        let date = {
            numrCert,
            nomeAbreviadoCs,
            numrCpfCs: numrCpfCs ? numrCpfCs.replace(/[^\w\s]|_/g, "") : null,
            numrMatriculaPessoalCs
        };

        await exportarAllLegadas(date).then((res) => {
            download(`data:application/excel;base64,${res.dadosRelatorioBase64}`, "Certidões Legadas.xlsx", "application/excel");
        });

    }

    // imprimir de todos elementos
    async function onImprimir() {
        let date = {
            numrCert,
            nomeAbreviadoCs,
            numrCpfCs: numrCpfCs ? numrCpfCs.replace(/[^\w\s]|_/g, "") : null,
            numrMatriculaPessoalCs
        };

        await imprimirAll(date).then((res) => {
            setBase64Imprimir('data:application/pdf;base64,' + res.dadosRelatorioBase64)
            setActiveImprimir(true)
        });
    }


    const onPaginacao = (event) => {

        let paginacao = `size=${event.rows}&page=${event.page}`
        buscaPersonalizadaCertidoesLegadas(paginacao, initialValueFilter).then((res) => {
            setCertidoesLegadasApi(res)
        });
        reduxDispatch(formik.values, event.page, event.rows)
    }


    return (
        <CardSeplag title="Certidões de Crédito - SEPLAG">
            <form className="p-col-12 p-grid p-fluid" onSubmit={formik.handleSubmit}>
                <RotuloSeplag nome="Beneficiário" cols="12 6 3" >
                    <InputText
                        name="nomeAbreviadoCs"
                        id='nomeAbreviadoCs'
                        value={formik.values.nomeAbreviadoCs}
                        style={{ width: '100%' }}
                        onChange={formik.handleChange}
                    />
                </RotuloSeplag>
                <RotuloSeplag nome="CPF" cols="12 6 3" >
                    <InputMask
                        mask="999.999.999-99"
                        value={formik.values.numrCpfCs}
                        onChange={formik.handleChange}
                        id="input_filtro"
                    />
                </RotuloSeplag>
                <RotuloSeplag nome="Matrícula" cols="12 6 3" >
                    <InputNumber
                        name="numrMatriculaPessoalCs"
                        useGrouping={false}
                        id='numrMatriculaPessoalCs'
                        value={formik.values.numrMatriculaPessoalCs}
                        style={{ width: '100%' }}
                        onValueChange={formik.handleChange}
                    />
                </RotuloSeplag>
                <RotuloSeplag nome="Nº Certidão de Crédito" cols="12 6 3" >
                    <InputNumber
                        name="numrCert"
                        id='numrCert'
                        value={formik.values.numrCert}
                        useGrouping={false}
                        style={{ width: '100%' }}
                        onValueChange={formik.handleChange}
                    />
                </RotuloSeplag>

                <RotuloSeplag nome="" cols="12 4 2" >
                    <div style={{ display: 'flex' }}>
                        <Button
                            type='submit'
                            label="Filtrar"
                            icon="pi pi-search"
                            className="p-button-raised"
                            style={{ marginRight: '5px' }}
                        />
                    </div>
                </RotuloSeplag>

            </form>

            <TableSeplag
                totalRecords={certidoesLegadasApi.totalElements}
                dados={certidoesLegadasApi.content}
                hasEventoAcao
                onModalSearch={onModalSearch}
                camposTabela={camposTabela}
                onView={(rowData) => onView(rowData)}
                onImpressao={(rowData) => onImpressao(rowData)}
                onExportar={() => onExportacao()}
                onImprimir={() => onImprimir()}
                onPage={onPaginacao}
                page={pagina}
                rows={row}
            />
            {/* modal para visualizar detalhes certidões legadas*/}

            {activeImprimir &&
                <CardExibirPDF
                    onHide={closeImprimir}
                    alturaTela="900"
                    tamanhoTela="980"
                    isExibirPDF={activeImprimir}
                    stringPDF={base64Imprimir}
                />
            }

            {
                showModalSearch &&
                <ModalConsultarCertidoesLegadas
                    show={showModalSearch}
                    setShow={setShowModalSearch}
                    rowData={form}
                    view={view}
                />
            }


        </CardSeplag>
    );
};

export default Index;
